import { tv, VariantProps } from "@/utils";

export const photo = tv({
  slots: {
    base: [],
    figure: [
      "overflow-hidden",
      "relative",
      "aspect-16/12",
      "rounded-xl",
      "bg-gray-300",
      "cursor-pointer",
    ],
    overlay: [],
    caption: [],
    label: [],
    title: [],
    description: [],
    image: ["object-center", "mix-blend-multiply"],
  },
  variants: {
    type: {
      photo: {
        overlay: [
          "before:absolute before:bottom-0 before:inset-x-0 before:z-10 before:w-full before:h-1/2",
          "before:bg-gradient-to-b before:from-transparent before:to-black",
        ],
        image: ["object-cover"],
        caption: ["absolute bottom-0 inset-x-0 z-20", "w-full", "p-8"],
        label: ["text-white"],
      },
      floor: {
        caption: ["mt-4"],
        image: ["object-contain", "!p-10"],
      },
    },
  },
  defaultVariants: {
    type: "photo",
  },
});

export type PhotoVariantProps = VariantProps<typeof photo>;

export type PhotoReturnVariantProps = ReturnType<typeof photo>;
